<template>
  <v-row>
    <v-card-title> Clientes </v-card-title>
    <DialogADD :component="this" :enterpriseId="this.component.enterpriseId" />
    <v-spacer></v-spacer>
    <v-col cols="12" sm="3">
      <v-select
        class="mt-3"
        label="Empresa"
        outlined
        :items="enterprises"
        v-model="component.enterpriseId"
        item-value="id"
        item-text="fantasyName"
        dense
        flat
        height="10px"
      ></v-select>
    </v-col>
    <v-btn
      v-if="component.permission.Cadastrar"
      class="mr-2 mt-6"
      color="success"
      @click="
        () => {
          activate_add();
        }
      "
      >Adicionar</v-btn
    >
  </v-row>
</template>

<script>
import DialogADD from "../AddDialog/";
import { GET_ALL_ENTERPRISE } from "./../../../store/actions/enterprise";
import { mapGetters } from "vuex";
export default {
  props: {
    component: Object,
  },
  components: { DialogADD },
  data: () => ({
    dialog: false,
    enterprises: Array(),
  }),
  methods: {
    activate_add() {
     this.$store.dispatch("setShowDialogRegisterClient",true)
    },
    async GetAll(page = 1) {
      let value = {
        page: page,
        limit: 10,
        paginate: false,
      };
      await this.$store.dispatch(GET_ALL_ENTERPRISE, value);
    },
  },
  created() {
    this.GetAll();
  },

  computed: {
    ...mapGetters(["getEnterprises"]),
  },

  watch: {
    getEnterprises(val) {
      
      if(val.data){
        this.enterprises = Object.values(val.data);
        this.component.enterpriseId = this.enterprises[0].id;
      }else{
        this.enterprises = Object.values(val);
        this.component.enterpriseId = this.enterprises[0].id;
      }
    },
  },
};
</script>
